import { Comment, Meta } from 'utils/types';

const comment = (data: Comment) => ({
  ...data,
  type: 'note',
  logType: data.type,
});

const comments = ({ data, meta }: { data: Comment[]; meta: Meta }) => ({
  meta,
  data: data.map((dat) => comment(dat)),
});

export default { comment, comments };
